import { ApiBase } from "../core/api-base";

export type AdInteractionType = "ad_click" | "banner_click";

export class AdClickTrackingApi extends ApiBase {
    public static async trackClick(adId: number, interactionType: AdInteractionType): Promise<void> {
        try {
            await super.apiPost(
                `/api/v1/ads/${String(adId)}/click`,
                { interaction_type: interactionType },
                { noSpinner: true },
            );
        } catch {
            // Ignore fire-and-forget tracking failures.
        }
    }
}
